import {Controller, useFormContext} from "react-hook-form";
import {StyledQuestionRequiredContainer} from "../../../../../../styles/onboarding/onboarding";
import {Switch} from "antd";
import {SessionSettingsFormFieldsType} from "../../../session/settings/types";

export function BundlePauseSettingFormField() {
  const {control} = useFormContext<SessionSettingsFormFieldsType>();
  return (
    <div>
      <Controller
        control={control}
        name="isPaused"
        render={({field: {value, onChange}}) => (
          <StyledQuestionRequiredContainer>
            <span className="required-text">Need a break? Pause this session</span>
            <Switch onChange={onChange} checked={value} />{" "}
          </StyledQuestionRequiredContainer>
        )}
      />
    </div>
  );
}
